import * as S from './styles';

import icon1 from '#assets/svg/Icon_profile.svg';
import icon2 from '#assets/svg/Icon_manage.svg';
import icon3 from '#assets/svg/Icon_portfolio.svg';
import icon4 from '#assets/svg/Icon_knowledge.svg';
import icon5 from '#assets/svg/Icon_expert.svg';

export const LandingTopContent = () => {
  return (
    <S.Container>
      <S.TextGray>이런 고민을 하고 있는 트레이너는</S.TextGray>
      <S.TextGradation>지금 바로 피벗을 시작하세요!</S.TextGradation>
      <S.GoalTags>
        <S.TagsGrid>
          {GoalTags.slice(0, 2).map((goal, index) => (
            <S.GoalTag key={index}>
              <span>{goal.pointText}</span>
              {goal.text}
            </S.GoalTag>
          ))}
        </S.TagsGrid>
        <S.TagsGrid>
          {GoalTags.slice(2).map((goal, index) => (
            <S.GoalTag key={index + 2}>
              <span>{goal.pointText}</span>
              {goal.text}
            </S.GoalTag>
          ))}
        </S.TagsGrid>
      </S.GoalTags>
      <S.BenefitContainer>
        <div>
          <S.TextWhite>트레이너들을 위한</S.TextWhite>
          <S.TextGradationBenefit>모든 것</S.TextGradationBenefit>
        </div>
        <S.BenefitCardGrid>
          {BenefitCardList.map((item, index) => {
            const ItemComponent = [S.Item1, S.Item2, S.Item3, S.Item4][index];
            return (
              <ItemComponent key={index}>
                <img src={item.icon} width={64} alt={item.title} />
                <p className="title">{item.title}</p>
                <p className="description">{item.description}</p>
              </ItemComponent>
            );
          })}
        </S.BenefitCardGrid>
      </S.BenefitContainer>
      <S.LandingTopFooter>
        <S.TextGradationFooter>이제, 트레이너들도</S.TextGradationFooter>
        <S.TextGradationFooter>달라져야 합니다</S.TextGradationFooter>
      </S.LandingTopFooter>
    </S.Container>
  );
};

const BenefitCardList = [
  {
    icon: icon1,
    title: '프로필',
    description:
      '나만의 프로필 페이지를 만들고 내 주변 고객들에게 노출하여 신규 회원을 창출할 수 있습니다.'
  },
  {
    icon: icon2,
    title: '회원 관리',
    description:
      '체계적인 회원 관리 기능을 통해 스마트한 트레이너로 브랜딩하고, 고객 만족도와 재등록률을 높일 수 있습니다.'
  },
  {
    icon: icon3,
    title: '트레이닝 성과',
    description:
      '회원의 변화 데이터가 담긴 트레이닝 성과를 자동으로 생성하고, 프로필에 노출하여 전문적인 트레이너로 브랜딩할 수 있습니다.'
  },
  {
    icon: icon5,
    title: '전문가 인증',
    description:
      '나의 전문성을 증명할 수 있는 전문가 인증을 통해 차별화된 브랜딩과 마케팅이 가능합니다.'
  }
  // {
  //   icon: icon4,
  //   title: '운동 지식',
  //   description:
  //     '실제 고객들의 운동 질문에 대한 답변과, 운동 지식 콘텐츠를 통해 나의 전문성을 드러낼 수 있습니다.'
  // },
];

const GoalTags = [
  {
    pointText: '신규 회원',
    text: '을 만나고 싶어요'
  },
  {
    pointText: '체계적인 회원 관리',
    text: '를 하고 싶어요'
  },
  {
    pointText: '재등록률',
    text: '을 올리고 싶어요'
  },
  {
    pointText: '전문성을 입증',
    text: '하고 싶어요 '
  },
  {
    pointText: '나만의 프로필',
    text: '을 만들고 싶어요'
  }
];
